import AnimateInView from '@atoms/AnimateInView/AnimateInView';
import Image from '@atoms/Image/Image';
import TextContent from '@atoms/TextContent/TextContent';
import Video from '@atoms/Video/Video';
import { IStorytellingModule } from '@models/IStorytellingModule';
import { VideoButton } from '@molecules/VideoButton/VideoButton';
import PositioningEnum from '@models/enums/PositioningEnum';
import SiteEnum from '@models/enums/SiteEnum';
import VerticalAlignmentEnum from '@models/enums/VerticalAlignmentEnum';
import classNames from 'classnames';

const StorytellingModule = ({
  site,
  cta,
  header,
  image,
  positioning,
  poster,
  subText,
  textAlignment,
  video,
  videoConfig,
  hasPlayButton,
  playButtonLabel,
  wrapperClasses = 'tw-container',
}: IStorytellingModule) => {
  const textContent = {
    header,
    subText,
    cta,
  };
  return (
    <AnimateInView className={classNames(wrapperClasses, 'tw-text-black-100')}>
      <div className="tw-grid tw-gap-sm md:tw-grid-cols-6 lg:tw-grid-cols-12 xl:tw-gap-md">
        <div
          className={classNames(
            'tw-relative tw-flex tw-items-center md:tw-col-span-3 lg:tw-col-span-6',
            positioning === PositioningEnum.Left
              ? 'md:tw-order-0 md:tw-col-start-1'
              : 'md:tw-order-1 md:tw-col-start-4 lg:tw-col-start-7'
          )}
        >
          {hasPlayButton && video && videoConfig ? (
            <div className="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
              <VideoButton
                darkFont = {false}
                playButtonLabel={playButtonLabel ?? "play"}
                videoSource={video.videoSource}
                videoConfig={videoConfig}
              />
            </div>
          ) : null}
          {video?.videoSource && !videoConfig && (
            <Video poster={poster} videoSource={video?.videoSource} />
          )}
          {image?.url && (
            <Image
              imageClasses="h-full"
              image={image}
              sizes="(max-width: 752px) 100vw, 50vw"
              aspectRatio={site === SiteEnum.B2B ? 1.6 : undefined}
            />
          )}
        </div>
        <div
          className={classNames(
            'tw-flex md:tw-col-span-3 lg:tw-col-span-5',
            textAlignment === VerticalAlignmentEnum.Top
              ? 'tw-items-start'
              : 'tw-items-center',
            positioning === PositioningEnum.Left
              ? 'md:tw-order-1 md:tw-col-start-4 lg:tw-col-start-8'
              : 'md:tw-order-0 md:tw-col-start-1'
          )}
        >
          <TextContent site={site} textContent={textContent} />
        </div>
      </div>
    </AnimateInView>
  );
};

export default StorytellingModule;
